(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mojjo-model-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mojjo-model-options')) {
    class MojjoModelOptions extends HTMLElement {
      static requests = new Map();
      static colours = new Set('siyah beyaz krem haki lacivert mavi kirmizi bordo yesil sari turuncu pembe mor gri gumus kahve kahverengi bej taba vizon ekru antrasit fume gold altin camel mint lila pudra tas yesili sax siyah-beyaz black white cream navy blue red green yellow orange pink purple grey gray silver brown beige tan khaki'.split(' '));
      static normalize(value) {
        return value.toLocaleLowerCase('tr-TR').replace(/ı/g, 'i').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[()[\],]/g, ' ').replace(/\s+/g, ' ').trim();
      }
      static brandGroups = [
        ['louis vuitton', 'lous vuitton', 'lv'],
        ['valentino', 'vlentno', 'vletino', 'vtino', 'vlnt', 'vln', 'vletno', 'vlntino'],
        ['dior', 'dr', 'cd'],
        ['gucci', 'gcc', 'gc'],
        ['prada', 'pradayeni', 'prda', 'prd'],
        ['nike', 'nk', 'dunk'],
        ['adidas', 'adids', 'addas', 'adizero', 'adizr', 'adize', 'adzro'],
        ['new balance', 'nb', 'nw blanc'],
        ['alexander mcqueen', 'alexander mc', 'alex mq', 'alex mc', 'alex'],
        ['christian louboutin', 'cristn loub', 'cristan loub', 'chistan loub'],
        ['premiata', 'prmata', 'prmta'],
        ['versace', 'vrsce', 'vrsc', 'wrsc'],
        ['hermes', 'hrms'],
        ['loewe', 'lwe', 'lowe'],
        ['calvin klein', 'ck'],
        ['armani exchange', 'ax'],
        ['emporio armani', 'armani', 'ea7', 'e7', 'ea'],
        ['lacoste', 'lacost', 'lcste', 'lcost', 'lcote', 'lcst'],
        ['dolce gabbana', 'dolce gabana', 'dolce ve gabbana', 'dg'],
        ['burberry', 'brbrry', 'burby', 'brbry'],
        ['fendi', 'fnd', 'fndi'],
        ['moschino', 'msch'],
        ['ray ban', 'rybn', 'ryb'],
        ['michael kors', 'michael k'],
        ['loro piana', 'lp'], ['boss', 'bss', 'bs'], ['jones', 'jt', 'jb'],
        ['cartier', 'ctier', 'crter'], ['celine', 'cne'], ['vans', 'vns'],
        ['moncler', 'mnclr'], ['golden goose', 'gg'], ['casalys blanca', 'csays bnca'],
        ['balmain', 'blmin', 'blmn'], ['siena blue', 'sb'], ['tommy hilfiger', 'tmy h'], ['off white', 'off-white']
      ];
      static model(title) {
        const normalized = this.normalize(title);
        let aliases;
        let brand;
        let rest = normalized;
        for (const group of this.brandGroups) {
          const alias = [...group].sort((a, b) => b.length - a.length).find(value => normalized === value || normalized.startsWith(value + ' '));
          if (alias) {
            aliases = group;
            brand = group[0];
            rest = normalized.slice(alias.length).trim();
            if (alias === 'dunk') rest = 'dunk ' + rest;
            if (['adizero', 'adizr', 'adize', 'adzro'].includes(alias)) rest = 'adizero ' + rest;
            break;
          }
        }
        if (!brand) {
          const first = normalized.split(' ')[0];
          if (!first) return null;
          if (['premium', 'erkek', 'kadin', 'ithal', 'unisex'].includes(first)) {
            aliases = [normalized];
            brand = normalized;
          } else {
            aliases = [first];
            brand = first;
            rest = normalized.slice(first.length).trim();
          }
        }
        const words = rest.replace(/[-/]+/g, ' ').split(' ').filter(Boolean);
        const modelWords = [];
        const colourWords = [];
        const translations = { black: 'siyah', white: 'beyaz', cream: 'krem', navy: 'lacivert', blue: 'mavi', red: 'kirmizi', green: 'yesil', yellow: 'sari', orange: 'turuncu', pink: 'pembe', purple: 'mor', grey: 'gri', gray: 'gri', silver: 'gumus', brown: 'kahverengi', kahve: 'kahverengi', beige: 'bej', tan: 'taba', khaki: 'haki', yesili: 'yesil', altin: 'gold' };
        for (let index = 0; index < words.length; index++) {
          const word = words[index];
          if (['aci', 'acik', 'koyu', 'su'].includes(word) && this.colours.has(words[index + 1])) {
            colourWords.push(word);
          } else if (this.colours.has(word)) {
            colourWords.push(translations[word] || word);
          } else {
            modelWords.push(word);
          }
        }
        if (!colourWords.length || !modelWords.some(word => !['ithal', 'erkek', 'kadin', 'unisex', 'premium', 'full', 'yeni', 'sezon'].includes(word))) return null;
        let query = aliases.map(alias => 'title:"' + alias.replace(/["\\]/g, '') + '"').join(' OR ');
        if (brand.length === 1 && modelWords.length) {
          query = modelWords.map(word => 'title:"' + word.replace(/["\\]/g, '') + '"').join(' AND ');
        }
        return { brand, aliases, key: [brand, ...modelWords].join(' '), colour: colourWords.join(' '), query };
      }
      static kind(title, type) {
        const words = this.normalize(title).split(' ');
        const types = [
          ['ayakkabi', ['sneaker', 'sneakers', 'ayakkabi']],
          ['terlik', ['terlik']], ['ceket', ['ceket']], ['mont', ['mont']],
          ['yelek', ['yelek']], ['hirka', ['hirka']], ['kazak', ['kazak']],
          ['tisort', ['tisort', 'tshirt', 'tişört', 't-shirt']],
          ['atlet', ['atlet']], ['boxer', ['boxer']], ['sort', ['sort']],
          ['kartlik', ['kartlik', 'cuzdan']], ['canta', ['canta', 'cantasi']],
          ['gozluk', ['gozluk', 'gozlugu']], ['parfum', ['parfum']]
        ];
        for (const [kind, aliases] of types) {
          if (aliases.some(alias => words.includes(this.normalize(alias)))) return kind;
        }
        const normalizedType = this.normalize(type || '');
        if (normalizedType.includes('ayakkabi')) return 'ayakkabi';
        if (normalizedType.includes('terlik')) return 'terlik';
        return normalizedType;
      }
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.dataset.state = 'loading';
        this.load().catch(() => { this.dataset.state = 'error'; this.started = false; });
      }
      async load() {
        const model = MojjoModelOptions.model(this.dataset.title);
        if (!model) { this.dataset.state = 'ready'; return; }
        const url = new URL(this.dataset.searchUrl, location.origin);
        url.searchParams.set('view', 'mojjo-models');
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[unavailable_products]', 'last');
        url.searchParams.set('options[prefix]', 'none');
        url.searchParams.set('q', '(' + model.query + ')');
        const requestKey = url.href;
        if (!MojjoModelOptions.requests.has(requestKey)) {
          MojjoModelOptions.requests.set(requestKey, (async () => {
            const products = [];
            const seen = new Set();
            let next = url;
            while (next && !seen.has(next.href)) {
              seen.add(next.href);
              const response = await fetch(next, { credentials: 'same-origin' });
              if (!response.ok) throw new Error('Model search unavailable');
              const result = await response.json();
              products.push(...result.products);
              next = result.next ? new URL(result.next, location.origin) : null;
              if (next) {
                next.searchParams.set('view', 'mojjo-models');
                next.searchParams.set('type', 'product');
              }
            }
            return products;
          })().catch(error => { MojjoModelOptions.requests.delete(requestKey); throw error; }));
        }
        const products = await MojjoModelOptions.requests.get(requestKey);
        const currentKind = MojjoModelOptions.kind(this.dataset.title, this.dataset.type);
        const family = products.filter(product => {
          const candidate = MojjoModelOptions.model(product.title);
          const candidateKind = MojjoModelOptions.kind(product.title, product.type);
          return candidate?.key === model.key && (!currentKind || !candidateKind || currentKind === candidateKind);
        });
        const colourIds = new Map([[model.colour, new Set([this.dataset.productId])]]);
        for (const product of family) {
          const colour = MojjoModelOptions.model(product.title).colour;
          if (!colourIds.has(colour)) colourIds.set(colour, new Set());
          colourIds.get(colour).add(String(product.id));
        }
        if (colourIds.get(model.colour).size > 1) { this.dataset.state = 'ready'; return; }
        if (!this.isConnected) return;
        const rail = this.querySelector('.mojjo-model-options__rail');
        const ids = new Set([this.dataset.productId]);
        for (const product of family) {
          const candidate = MojjoModelOptions.model(product.title);
          const id = String(product.id);
          if (ids.has(id) || !product.image || !candidate || candidate.brand !== model.brand) continue;
          const candidateKind = MojjoModelOptions.kind(product.title, product.type);
          if (currentKind && candidateKind && currentKind !== candidateKind) continue;
          if (candidate.key !== model.key || candidate.colour === model.colour || colourIds.get(candidate.colour).size !== 1) continue;
          ids.add(id);
          const card = document.createElement('a');
          card.className = 'mojjo-model-options__card' + (product.available ? '' : ' mojjo-model-options__card--sold-out');
          const productUrl = new URL(product.url, location.origin);
          if (productUrl.origin !== location.origin) continue;
          productUrl.search = '';
          card.href = productUrl.pathname;
          card.title = product.title;
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title;
          image.width = 176;
          image.height = 176;
          image.loading = 'lazy';
          const name = document.createElement('span');
          name.className = 'mojjo-model-options__name';
          name.textContent = product.title;
          card.append(image, name);
          if (!product.available) {
            const stock = document.createElement('span');
            stock.className = 'mojjo-model-options__stock';
            stock.textContent = this.dataset.soldOut;
            card.append(stock);
          }
          rail.append(card);
        }
        this.querySelector('nav').hidden = ids.size < 2;
        this.dataset.state = 'ready';
      }
    }
    customElements.define('mojjo-model-options', MojjoModelOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
